import script from "./LtcsScheduleScreenPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtcsScheduleScreenPage.vue?vue&type=script&setup=true&lang=ts"

import "./LtcsScheduleScreenPage.vue?vue&type=style&index=0&id=79759194&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79759194"]])

export default __exports__